import axios from '../../http_v2'
export default {
  list: (params) => {
    return axios.post('activityservice/contact/page', params)
  },
  add: (params) => {
    // 新增修改统一接口
    return axios.post('activityservice/contact/upsert', params)
  },
  tissueTree: (params) => {
    return axios.post('opservice/org/tree', params)
  },
  treeArr: (params) => {
    return axios.get('activityservice/contactOrg/listAll', params)
  },
  treeSave: (params) => {
    return axios.post('activityservice/contactOrg/saveAll', params)
  },
  updateAll: (params) => {
    // 批量修改接口 启用/禁用功能
    return axios.post('activityservice/contact/batch', params)
  },
  delAll: (params) => {
    return axios.post('activityservice/contact/batchdelete', params)
  },
  export: (params) => {
    return axios.post('activityservice/contact/export', params)
  },
  promise: (params) => {
    return axios.get('/activityservice/privilege/list/' + params)
  },
  promistUpdate: (params) => {
    return axios.post('activityservice/privilege/upsert', params)
  },
  getTree: (params) => {
    return axios.get('activityservice/contactOrg/tree', params)
  }
}